export default "__VITE_ASSET__bf122040__"